import type { oz } from '@weft/utils';
import { segregated } from '../../utils/segregated';
import { NewCustomerSchema } from './new-customer-schema';

export const CustomerSchema = segregated(NewCustomerSchema).openapi('Customer');

export type Customer = oz.infer<typeof CustomerSchema>;